/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LocationMapIcon16Light = forwardRef('LocationMapIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.83 2.026a1.5 1.5 0 0 1 1.34 0L9.5 3.691l3.415-1.707a.75.75 0 0 1 1.085.67v8.941a.75.75 0 0 1-.415.671l-3.414 1.707a1.5 1.5 0 0 1-1.342 0L5.5 12.31l-3.415 1.707A.75.75 0 0 1 1 13.346V4.403a.75.75 0 0 1 .415-.67l3.414-1.708ZM2 4.56l3-1.5v8.382l-3 1.5V4.559Zm7 8.382-3-1.5V3.059l3 1.5v8.382Zm1 0 3-1.5V3.059l-3 1.5v8.382Z" })));
});
